export default __webpack_public_path__ + "static/media/academia.7afd7c69.svg";